// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.2.4
//   protoc               v5.28.2
// source: stcs_wapp_svc_settings.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { grpc } from "@improbable-eng/grpc-web";
import { BrowserHeaders } from "browser-headers";
import { Observable } from "rxjs";
import { take } from "rxjs/operators";
import { GenericPayloadResponse } from "./stcs_commons.entity";
import { StcsWappSettingsConfig } from "./stcs_wapp_settings.entity";

export const protobufPackage = "stcs_cmw";

export interface GetWappSettingsRequest {
  ref_id_user: string;
  ref_id_org: string;
}

export interface UpdateOrgWappSettingsRequest {
  ref_id_user: string;
  ref_id_org: string;
  stcs_wapp_settings_config: StcsWappSettingsConfig | undefined;
}

export interface UpdateCompWappSettingsRequest {
  ref_id_user: string;
  ref_id_org: string;
  ref_id_comp: string;
  stcs_wapp_settings_config: StcsWappSettingsConfig | undefined;
}

export interface UpdateCompUserWappSettingsRequest {
  ref_id_user: string;
  ref_id_org: string;
  ref_id_comp: string;
  stcs_wapp_settings_config: StcsWappSettingsConfig | undefined;
}

function createBaseGetWappSettingsRequest(): GetWappSettingsRequest {
  return { ref_id_user: "", ref_id_org: "" };
}

export const GetWappSettingsRequest: MessageFns<GetWappSettingsRequest> = {
  encode(message: GetWappSettingsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetWappSettingsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetWappSettingsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetWappSettingsRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
    };
  },

  toJSON(message: GetWappSettingsRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetWappSettingsRequest>, I>>(base?: I): GetWappSettingsRequest {
    return GetWappSettingsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetWappSettingsRequest>, I>>(object: I): GetWappSettingsRequest {
    const message = createBaseGetWappSettingsRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    return message;
  },
};

function createBaseUpdateOrgWappSettingsRequest(): UpdateOrgWappSettingsRequest {
  return { ref_id_user: "", ref_id_org: "", stcs_wapp_settings_config: undefined };
}

export const UpdateOrgWappSettingsRequest: MessageFns<UpdateOrgWappSettingsRequest> = {
  encode(message: UpdateOrgWappSettingsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    if (message.stcs_wapp_settings_config !== undefined) {
      StcsWappSettingsConfig.encode(message.stcs_wapp_settings_config, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateOrgWappSettingsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateOrgWappSettingsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.stcs_wapp_settings_config = StcsWappSettingsConfig.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateOrgWappSettingsRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
      stcs_wapp_settings_config: isSet(object.stcs_wapp_settings_config)
        ? StcsWappSettingsConfig.fromJSON(object.stcs_wapp_settings_config)
        : undefined,
    };
  },

  toJSON(message: UpdateOrgWappSettingsRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    if (message.stcs_wapp_settings_config !== undefined) {
      obj.stcs_wapp_settings_config = StcsWappSettingsConfig.toJSON(message.stcs_wapp_settings_config);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateOrgWappSettingsRequest>, I>>(base?: I): UpdateOrgWappSettingsRequest {
    return UpdateOrgWappSettingsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateOrgWappSettingsRequest>, I>>(object: I): UpdateOrgWappSettingsRequest {
    const message = createBaseUpdateOrgWappSettingsRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    message.stcs_wapp_settings_config =
      (object.stcs_wapp_settings_config !== undefined && object.stcs_wapp_settings_config !== null)
        ? StcsWappSettingsConfig.fromPartial(object.stcs_wapp_settings_config)
        : undefined;
    return message;
  },
};

function createBaseUpdateCompWappSettingsRequest(): UpdateCompWappSettingsRequest {
  return { ref_id_user: "", ref_id_org: "", ref_id_comp: "", stcs_wapp_settings_config: undefined };
}

export const UpdateCompWappSettingsRequest: MessageFns<UpdateCompWappSettingsRequest> = {
  encode(message: UpdateCompWappSettingsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    if (message.ref_id_comp !== "") {
      writer.uint32(26).string(message.ref_id_comp);
    }
    if (message.stcs_wapp_settings_config !== undefined) {
      StcsWappSettingsConfig.encode(message.stcs_wapp_settings_config, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateCompWappSettingsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateCompWappSettingsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ref_id_comp = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.stcs_wapp_settings_config = StcsWappSettingsConfig.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateCompWappSettingsRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
      ref_id_comp: isSet(object.ref_id_comp) ? globalThis.String(object.ref_id_comp) : "",
      stcs_wapp_settings_config: isSet(object.stcs_wapp_settings_config)
        ? StcsWappSettingsConfig.fromJSON(object.stcs_wapp_settings_config)
        : undefined,
    };
  },

  toJSON(message: UpdateCompWappSettingsRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    if (message.ref_id_comp !== "") {
      obj.ref_id_comp = message.ref_id_comp;
    }
    if (message.stcs_wapp_settings_config !== undefined) {
      obj.stcs_wapp_settings_config = StcsWappSettingsConfig.toJSON(message.stcs_wapp_settings_config);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateCompWappSettingsRequest>, I>>(base?: I): UpdateCompWappSettingsRequest {
    return UpdateCompWappSettingsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateCompWappSettingsRequest>, I>>(
    object: I,
  ): UpdateCompWappSettingsRequest {
    const message = createBaseUpdateCompWappSettingsRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    message.ref_id_comp = object.ref_id_comp ?? "";
    message.stcs_wapp_settings_config =
      (object.stcs_wapp_settings_config !== undefined && object.stcs_wapp_settings_config !== null)
        ? StcsWappSettingsConfig.fromPartial(object.stcs_wapp_settings_config)
        : undefined;
    return message;
  },
};

function createBaseUpdateCompUserWappSettingsRequest(): UpdateCompUserWappSettingsRequest {
  return { ref_id_user: "", ref_id_org: "", ref_id_comp: "", stcs_wapp_settings_config: undefined };
}

export const UpdateCompUserWappSettingsRequest: MessageFns<UpdateCompUserWappSettingsRequest> = {
  encode(message: UpdateCompUserWappSettingsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    if (message.ref_id_comp !== "") {
      writer.uint32(26).string(message.ref_id_comp);
    }
    if (message.stcs_wapp_settings_config !== undefined) {
      StcsWappSettingsConfig.encode(message.stcs_wapp_settings_config, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateCompUserWappSettingsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateCompUserWappSettingsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ref_id_comp = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.stcs_wapp_settings_config = StcsWappSettingsConfig.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateCompUserWappSettingsRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
      ref_id_comp: isSet(object.ref_id_comp) ? globalThis.String(object.ref_id_comp) : "",
      stcs_wapp_settings_config: isSet(object.stcs_wapp_settings_config)
        ? StcsWappSettingsConfig.fromJSON(object.stcs_wapp_settings_config)
        : undefined,
    };
  },

  toJSON(message: UpdateCompUserWappSettingsRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    if (message.ref_id_comp !== "") {
      obj.ref_id_comp = message.ref_id_comp;
    }
    if (message.stcs_wapp_settings_config !== undefined) {
      obj.stcs_wapp_settings_config = StcsWappSettingsConfig.toJSON(message.stcs_wapp_settings_config);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateCompUserWappSettingsRequest>, I>>(
    base?: I,
  ): UpdateCompUserWappSettingsRequest {
    return UpdateCompUserWappSettingsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateCompUserWappSettingsRequest>, I>>(
    object: I,
  ): UpdateCompUserWappSettingsRequest {
    const message = createBaseUpdateCompUserWappSettingsRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    message.ref_id_comp = object.ref_id_comp ?? "";
    message.stcs_wapp_settings_config =
      (object.stcs_wapp_settings_config !== undefined && object.stcs_wapp_settings_config !== null)
        ? StcsWappSettingsConfig.fromPartial(object.stcs_wapp_settings_config)
        : undefined;
    return message;
  },
};

export interface StcsWappSvcSettings {
  get_org_wapp_settings(
    request: DeepPartial<GetWappSettingsRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse>;
  update_org_wapp_settings(
    request: DeepPartial<UpdateOrgWappSettingsRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse>;
  update_comp_wapp_settings(
    request: DeepPartial<UpdateCompWappSettingsRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse>;
  update_comp_user_wapp_settings(
    request: DeepPartial<UpdateCompUserWappSettingsRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse>;
}

export class StcsWappSvcSettingsClientImpl implements StcsWappSvcSettings {
  private readonly rpc: Rpc;

  constructor(rpc: Rpc) {
    this.rpc = rpc;
    this.get_org_wapp_settings = this.get_org_wapp_settings.bind(this);
    this.update_org_wapp_settings = this.update_org_wapp_settings.bind(this);
    this.update_comp_wapp_settings = this.update_comp_wapp_settings.bind(this);
    this.update_comp_user_wapp_settings = this.update_comp_user_wapp_settings.bind(this);
  }

  get_org_wapp_settings(
    request: DeepPartial<GetWappSettingsRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse> {
    return this.rpc.unary(
      StcsWappSvcSettingsget_org_wapp_settingsDesc,
      GetWappSettingsRequest.fromPartial(request),
      metadata,
    );
  }

  update_org_wapp_settings(
    request: DeepPartial<UpdateOrgWappSettingsRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse> {
    return this.rpc.unary(
      StcsWappSvcSettingsupdate_org_wapp_settingsDesc,
      UpdateOrgWappSettingsRequest.fromPartial(request),
      metadata,
    );
  }

  update_comp_wapp_settings(
    request: DeepPartial<UpdateCompWappSettingsRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse> {
    return this.rpc.unary(
      StcsWappSvcSettingsupdate_comp_wapp_settingsDesc,
      UpdateCompWappSettingsRequest.fromPartial(request),
      metadata,
    );
  }

  update_comp_user_wapp_settings(
    request: DeepPartial<UpdateCompUserWappSettingsRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse> {
    return this.rpc.unary(
      StcsWappSvcSettingsupdate_comp_user_wapp_settingsDesc,
      UpdateCompUserWappSettingsRequest.fromPartial(request),
      metadata,
    );
  }
}

export const StcsWappSvcSettingsDesc = { serviceName: "stcs_cmw.StcsWappSvcSettings" };

export const StcsWappSvcSettingsget_org_wapp_settingsDesc: UnaryMethodDefinitionish = {
  methodName: "get_org_wapp_settings",
  service: StcsWappSvcSettingsDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return GetWappSettingsRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcSettingsupdate_org_wapp_settingsDesc: UnaryMethodDefinitionish = {
  methodName: "update_org_wapp_settings",
  service: StcsWappSvcSettingsDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return UpdateOrgWappSettingsRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcSettingsupdate_comp_wapp_settingsDesc: UnaryMethodDefinitionish = {
  methodName: "update_comp_wapp_settings",
  service: StcsWappSvcSettingsDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return UpdateCompWappSettingsRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcSettingsupdate_comp_user_wapp_settingsDesc: UnaryMethodDefinitionish = {
  methodName: "update_comp_user_wapp_settings",
  service: StcsWappSvcSettingsDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return UpdateCompUserWappSettingsRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

interface UnaryMethodDefinitionishR extends grpc.UnaryMethodDefinition<any, any> {
  requestStream: any;
  responseStream: any;
}

type UnaryMethodDefinitionish = UnaryMethodDefinitionishR;

interface Rpc {
  unary<T extends UnaryMethodDefinitionish>(
    methodDesc: T,
    request: any,
    metadata: grpc.Metadata | undefined,
  ): Observable<any>;
}

export class GrpcWebImpl {
  private host: string;
  private options: {
    transport?: grpc.TransportFactory;

    debug?: boolean;
    metadata?: grpc.Metadata;
    upStreamRetryCodes?: number[];
  };

  constructor(
    host: string,
    options: {
      transport?: grpc.TransportFactory;

      debug?: boolean;
      metadata?: grpc.Metadata;
      upStreamRetryCodes?: number[];
    },
  ) {
    this.host = host;
    this.options = options;
  }

  unary<T extends UnaryMethodDefinitionish>(
    methodDesc: T,
    _request: any,
    metadata: grpc.Metadata | undefined,
  ): Observable<any> {
    const request = { ..._request, ...methodDesc.requestType };
    const maybeCombinedMetadata = metadata && this.options.metadata
      ? new BrowserHeaders({ ...this.options?.metadata.headersMap, ...metadata?.headersMap })
      : metadata ?? this.options.metadata;
    return new Observable((observer) => {
      grpc.unary(methodDesc, {
        request,
        host: this.host,
        metadata: maybeCombinedMetadata ?? {},
        ...(this.options.transport !== undefined ? { transport: this.options.transport } : {}),
        debug: this.options.debug ?? false,
        onEnd: (next) => {
          if (next.status !== 0) {
            const err = new GrpcWebError(next.statusMessage, next.status, next.trailers);
            observer.error(err);
          } else {
            observer.next(next.message as any);
            observer.complete();
          }
        },
      });
    }).pipe(take(1));
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export class GrpcWebError extends globalThis.Error {
  constructor(message: string, public code: grpc.Code, public metadata: grpc.Metadata) {
    super(message);
  }
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
